import React from "react";

export const ItemList = ({
  listType,
  children,
}: {
  listType?: string;
  children?: any;
}) => {
  return (
    <div
      className={[
        "grid",
        "grid-cols-1",
        "gap-x-6",
        "gap-y-10",
        "sm:grid-cols-1",
        "lg:grid-cols-2",
        "xl:gap-x-8",
        "justify-center",
        `${
          listType?.toLowerCase() === "image focused" &&
          "grid-cols-2 sm:grid-cols-2 lg:grid-cols-4"
        }`,
        `${
          listType?.toLowerCase() === "description focused" &&
          " grid-cols-1 sm:grid-cols-1 lg:grid-cols-2"
        }`,
      ].join(" ")}
    >
      {children}
    </div>
  );
};
